import { c as _c } from "react/compiler-runtime";
import { Edit03Icon, LogOut01Icon, PlusCircleIcon, Save01Icon } from '@systemeio/icons';
import { SmsTemplateForm, SmsTemplateFormProps } from 'modules/sms/components/sms-template-form';
import { SmsTemplateRadioGroupSenderType } from 'modules/sms/components/sms-template-radio-group-sender-type';
import { defaultSmsTemplateValues } from 'modules/sms/constants/default-sms-template-values';
import { useSmsTemplate } from 'modules/sms/hooks/use-sms-template';
import { SenderTypeEnum, SmsTemplateCreateInterface } from 'modules/sms/types';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { Breadcrumbs, Button, FormInput, Modal, Tooltip, type BreadcrumbsData } from 'shared/components';
import { Page } from 'shared/components/page';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { CONTENT_CLASSNAME } from 'shared/layout/constants/layout-class-names';
import { twMerge } from 'tailwind-merge';
type SmsTemplateFlowStep = 'closed' | 'setup' | 'editor';
interface Props extends Pick<SmsTemplateFormProps, 'templateId' | 'onSuccess'> {
  noRedirectOnNotFoundError?: boolean;
}
const senderErrors = {
  phoneNumber: '',
  alphanumericSender: '',
  messageServiceSid: ''
};
export function SmsTemplateFlow(t0) {
  const $ = _c(88);
  const {
    templateId,
    onSuccess,
    noRedirectOnNotFoundError
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const router = useRouter();
  const [step, setStep] = useState("closed");
  const [draft, setDraft] = useState(defaultSmsTemplateValues);
  const [isFetching, setIsFetching] = useState(false);
  const [hasTwilioErrors, setHasTwilioErrors] = useState(false);
  const {
    template
  } = useSmsTemplate(templateId, noRedirectOnNotFoundError);
  let t1;
  if ($[0] !== draft.alphanumericSender || $[1] !== draft.messageServiceSid || $[2] !== draft.phoneNumber) {
    t1 = {
      [SenderTypeEnum.PhoneNumber]: draft.phoneNumber,
      [SenderTypeEnum.Alphanumeric]: draft.alphanumericSender,
      [SenderTypeEnum.MessageService]: draft.messageServiceSid
    };
    $[0] = draft.alphanumericSender;
    $[1] = draft.messageServiceSid;
    $[2] = draft.phoneNumber;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const selectedSender = t1[draft.senderType];
  let t2;
  if ($[4] !== draft.name || $[5] !== selectedSender) {
    t2 = draft.name.trim().length > 0 && Boolean(selectedSender);
    $[4] = draft.name;
    $[5] = selectedSender;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const isSetupValid = t2;
  const editorData = templateId ? template : draft;
  let t3;
  if ($[7] !== t) {
    t3 = t("dashboard.automation_rule.title_plural");
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = {
      caption: t3,
      href: "/automation-rules",
      isStatic: true
    };
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== router.pathname) {
    t5 = router.pathname.includes("/create") ? "dashboard.automation_rule.edit.create_title" : "dashboard.automation_rule.edit.title";
    $[11] = router.pathname;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t || $[14] !== t5) {
    t6 = t(t5);
    $[13] = t;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t6) {
    t7 = {
      caption: t6,
      isStatic: true
    };
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const t8 = editorData?.name ?? "";
  let t9;
  if ($[18] !== t8) {
    t9 = {
      caption: t8,
      isStatic: true
    };
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t4 || $[21] !== t7 || $[22] !== t9) {
    t10 = [t4, t7, t9];
    $[20] = t4;
    $[21] = t7;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  const breadcrumbsData = t10;
  let t11;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => setStep("closed");
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  const closeFlow = t11;
  const t12 = templateId ? "dashboard.automation_rule.edit.edit_sms" : "dashboard.automation_rule.edit.create_sms";
  let t13;
  if ($[25] !== t || $[26] !== t12) {
    t13 = t(t12);
    $[25] = t;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  const t14 = templateId ? "dashboard.automation_rule.edit.edit_sms" : "dashboard.automation_rule.edit.create_sms";
  let t15;
  if ($[28] !== t || $[29] !== t14) {
    t15 = t(t14);
    $[28] = t;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== templateId) {
    t16 = () => setStep(templateId ? "editor" : "setup");
    $[31] = templateId;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  const t17 = templateId ? "ghost-color" : "gray";
  let t18;
  if ($[33] !== templateId) {
    t18 = templateId ? <Edit03Icon /> : <PlusCircleIcon />;
    $[33] = templateId;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== t15 || $[36] !== t16 || $[37] !== t17 || $[38] !== t18) {
    t19 = <Button aria-label={t15} onClick={t16} size="icon-sm" variant={t17}>{t18}</Button>;
    $[35] = t15;
    $[36] = t16;
    $[37] = t17;
    $[38] = t18;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== t13 || $[41] !== t19) {
    t20 = <Tooltip mode="hover" label={t13}>{t19}</Tooltip>;
    $[40] = t13;
    $[41] = t19;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  const t21 = step === "setup";
  let t22;
  if ($[43] !== t) {
    t22 = t("dashboard.sms.create_sms_template");
    $[43] = t;
    $[44] = t22;
  } else {
    t22 = $[44];
  }
  let t23;
  if ($[45] !== t) {
    t23 = t("global.cancel");
    $[45] = t;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  let t24;
  if ($[47] !== t23) {
    t24 = <Button type="button" onClick={closeFlow} variant="secondary" size="md">{t23}</Button>;
    $[47] = t23;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  const t25 = !isSetupValid || hasTwilioErrors;
  let t26;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = () => setStep("editor");
    $[49] = t26;
  } else {
    t26 = $[49];
  }
  let t27;
  if ($[50] !== t) {
    t27 = t("dashboard.sms.save_and_edit");
    $[50] = t;
    $[51] = t27;
  } else {
    t27 = $[51];
  }
  let t28;
  if ($[52] !== t25 || $[53] !== t27) {
    t28 = <Button type="button" disabled={t25} onClick={t26} variant="primary" size="md">{t27}</Button>;
    $[52] = t25;
    $[53] = t27;
    $[54] = t28;
  } else {
    t28 = $[54];
  }
  let t29;
  if ($[55] !== t24 || $[56] !== t28) {
    t29 = <>{t24}{t28}</>;
    $[55] = t24;
    $[56] = t28;
    $[57] = t29;
  } else {
    t29 = $[57];
  }
  let t30;
  if ($[58] !== t) {
    t30 = t("dashboard.sms.template_name");
    $[58] = t;
    $[59] = t30;
  } else {
    t30 = $[59];
  }
  let t31;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = event => setDraft(prev => ({
      ...prev,
      name: event.target.value
    }));
    $[60] = t31;
  } else {
    t31 = $[60];
  }
  let t32;
  if ($[61] !== draft.name || $[62] !== t30) {
    t32 = <FormInput label={t30} required={true} value={draft.name} onChange={t31} />;
    $[61] = draft.name;
    $[62] = t30;
    $[63] = t32;
  } else {
    t32 = $[63];
  }
  let t33;
  if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = sender => setDraft(prev_0 => ({
      ...prev_0,
      ...sender
    }));
    $[64] = t33;
  } else {
    t33 = $[64];
  }
  let t34;
  if ($[65] !== draft) {
    t34 = <SmsTemplateRadioGroupSenderType withTwilioAlert={true} errors={senderErrors} isFetching={false} isPreFetching={false} values={draft} onChange={t33} onTwilioHasErrors={setHasTwilioErrors} />;
    $[65] = draft;
    $[66] = t34;
  } else {
    t34 = $[66];
  }
  let t35;
  if ($[67] !== t32 || $[68] !== t34) {
    t35 = <div className="flex flex-col gap-5">{t32}{t34}</div>;
    $[67] = t32;
    $[68] = t34;
    $[69] = t35;
  } else {
    t35 = $[69];
  }
  let t36;
  if ($[70] !== t21 || $[71] !== t22 || $[72] !== t29 || $[73] !== t35) {
    t36 = <Modal opened={t21} onClose={closeFlow} title={t22} footer={t29}>{t35}</Modal>;
    $[70] = t21;
    $[71] = t22;
    $[72] = t29;
    $[73] = t35;
    $[74] = t36;
  } else {
    t36 = $[74];
  }
  let t37;
  if ($[75] !== breadcrumbsData || $[76] !== editorData || $[77] !== hasTwilioErrors || $[78] !== isFetching || $[79] !== onSuccess || $[80] !== step || $[81] !== t || $[82] !== templateId) {
    t37 = step === "editor" && <div className="bg-bg-page fixed inset-x-0 top-(--dashboard-navbar-height) bottom-0 z-40 overflow-y-auto overscroll-contain [--sticky-top:0px]"><Page className={twMerge(CONTENT_CLASSNAME, "py-5")}><Page.Header className="px-0" actions={[<Button key="exit" aria-label={t("global.exit")} type="button" disabled={isFetching} onClick={closeFlow} variant="secondary" size="sm"><LogOut01Icon /><span className="tablet:inline hidden">{t("global.exit")}</span></Button>, <Button key="save" aria-label={t("global.save")} form={SmsTemplateForm.formId} type="submit" disabled={!editorData || hasTwilioErrors} isLoading={isFetching} variant="primary" size="sm"><Save01Icon /><span className="tablet:inline hidden">{t("global.save")}</span></Button>]}><Breadcrumbs data={breadcrumbsData} isFetching={!editorData} /></Page.Header><Page.Body><SmsTemplateForm templateId={templateId} data={editorData} onStatusChange={t38 => {
            const {
              isFetching: isFetching_0,
              hasTwilioErrors: hasTwilioErrors_0
            } = t38;
            setIsFetching(isFetching_0);
            setHasTwilioErrors(hasTwilioErrors_0);
          }} onSuccess={async data => {
            await onSuccess?.(data);
            closeFlow();
          }} /></Page.Body></Page></div>;
    $[75] = breadcrumbsData;
    $[76] = editorData;
    $[77] = hasTwilioErrors;
    $[78] = isFetching;
    $[79] = onSuccess;
    $[80] = step;
    $[81] = t;
    $[82] = templateId;
    $[83] = t37;
  } else {
    t37 = $[83];
  }
  let t38;
  if ($[84] !== t20 || $[85] !== t36 || $[86] !== t37) {
    t38 = <>{t20}{t36}{t37}</>;
    $[84] = t20;
    $[85] = t36;
    $[86] = t37;
    $[87] = t38;
  } else {
    t38 = $[87];
  }
  return t38;
}